
import {tap, map, filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseService } from '@shared/services/base.service';
import { IAuthState } from '@state/reducers/auth/auth.reducer';
import { IState } from '@state/state.module';
import { Observable } from 'rxjs';
import { IDecodedToken } from '@state/reducers/auth/auth.models';

@Injectable()
export class PermissionService extends BaseService {

    constructor(private store: Store<IState>) {
        super();

        this.onInit();
    }

    private state$: Observable<IAuthState>;
    private permissions: any = [];

    public onInit() {
        this.state$ = this.store.select(x => x.auth);

        this.state$.pipe(
            filter(state => !!state),
            filter(state => !state.tokenRefreshPending),
            filter(state => !!state.principal.token),
            filter(state => !!state.principal.token.encoded),
            filter(state => !!state.principal.token.decoded),
            map(state => state.principal.token.decoded),
            tap(this.retainPermissionsOnly.bind(this)),)
            .subscribe();
    }

    private retainPermissionsOnly(decodedToken: IDecodedToken) {
        const tokenPropertyNames = Object.keys(decodedToken);
        // we assume that a permission is every property-name in the token that has 'allow' set as value;
        const permissions = tokenPropertyNames?.filter(propertyName => {
            return decodedToken[propertyName] === 'allow';
        });
        this.permissions = permissions;
    }

    public hasPermission(...permissions: string[]): boolean {
        let result = false;

        if (this.permissions) {
            if (this.permissions instanceof Array) {
                for (const permission of permissions) {
                    result = !!this.permissions.find(x => x === permission);
                    if (!!result) { break; }
                }
            } else {
                for (const permission of permissions) {
                    result = !!(this.permissions === permission);
                    if (!!result) { break; }
                }
            }
        }

        return result;
    }
}
